<template>
  <div class="run-fence">
    <div class="breadcrumb" style="font-size: 14px">
      设置围栏
      <el-button class="right_f" type="primary" @click="cancel">返回</el-button>
      <el-button class="right_f" type="primary" @click="addNewFence">新增围栏</el-button>
    </div>
    <div class="com-list">
      <el-table :data="fenceList" border>
        <el-table-column type="index" label="序号" align="center" width="120" />
        <el-table-column prop="name" label="围栏名称" align="center"></el-table-column>
        <el-table-column label="跑区" align="center" inline-template>
          <div>{{ row.runAreaNames && row.runAreaNames.length && row.runAreaNames.join(',') }}</div>
        </el-table-column>
        <el-table-column align="center" label="框定点位" inline-template>
          <span>{{ row.runGeoFencePoints ? row.runGeoFencePoints.map(item => item.serialNum).join(',') : '' }}</span>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" align="center"></el-table-column>
        <el-table-column label="操作" inline-template align="center">
          <div>
            <el-button type="text" size="small" @click="toFenceDetail(row)">围栏信息</el-button>
            <el-button type="text" size="small" @click="showDeleteFence(row)">删除</el-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="删除围栏" v-model="deleteFenceVisible" :modal-append-to-body="false">
      <p>确定删除此围栏吗？</p>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteFence">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fenceList: [
        { index: 1, fenceName: "第一围栏", time: "2019/7/25", fenceId: "112" },
      ],
      unid: "",
      deleteFenceVisible: false,
      deleteFenceId: "",
    };
  },
  mounted() {
    this.unid = this.$util.getUrlParam("unid");
    this.getFenceList();
  },
  methods: {
    // 获取围栏列表
    getFenceList() {
      this.fenceList = [];

      this.$http({
        method: "GET",
        url: this.$util.domain + "/adminapi/v1/campus/geoFence/list",
        params: {
          unid: this.unid,
        },
      }).then((response) => {
        if (response.data.error == 10000) {
          this.fenceList = response.data.data;
          this.fenceList.forEach((element) => {
            element.createdAt = new Date(element.createdAt).format(
              "yyyy/MM/dd"
            );
          });
        }
      });
    },
    showDeleteFence(row) {
      this.deleteFenceId = row.id;
      this.deleteFenceVisible = true;
    },
    // 删除
    deleteFence() {
      let fenceId = this.deleteFenceId;
      this.$http({
        method: "GET",
        url: this.$util.domain + "/adminapi/v1/campus/geoFence/delete",
        params: {
          id: fenceId,
          unid: this.unid,
        },
      }).then((response) => {
        if (response.data.error == 10000) {
          this.deleteFenceId = "";
          this.deleteFenceVisible = false;
          this.$util.successMsg("围栏删除成功！");
          this.getFenceList();
        }
      });
    },
    // 围栏信息
    toFenceDetail(row) {
      let id = row.id;
      location.href = `/#/xiaoyuan/GX/newFence?id=${id}&unid=${this.unid}`;
    },
    addNewFence() {
      // 新增围栏
      location.href = `/#/xiaoyuan/GX/newFence?unid=${this.unid}`;
    },
    cancel() {
      location.href = `/#/xiaoyuan/GX/pointManage?unid=${this.unid}`;
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// runningFence.vue?76397610